import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

const CashoutPage = () => {
  const navigate = useNavigate();

  return (
    <main className="w-full h-full p-6 max-w-3xl mx-auto">
      <Card className="bg-gray-800/50 border-gray-700">
        <CardHeader>
          <CardTitle className="text-white">Instant Cashout Disabled</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4 text-gray-300">
          <p>
            YSR now uses manual artist payouts with Trust Payments settlement.
            Instant Stripe cashout is no longer used.
          </p>
          <p>
            Go to your payouts page to submit a manual payout request with UK
            bank details.
          </p>
          <Button className="bg-purple-600 hover:bg-purple-700 text-white" onClick={() => navigate('/admin/payouts')}>
            Go to Payouts
          </Button>
        </CardContent>
      </Card>
    </main>
  );
};

export default CashoutPage;
